export default function HomePageSEO() {
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        name: "韩漫网",
        url: "https://www.hanmanwang.com",
        description: "在韩漫网，免费在线看好看的漫画和韩国漫画，资源齐全加载快速，涵盖热血、爱情、冒险等多种题材。",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://www.hanmanwang.com/search?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@type": "Organization",
        name: "韩漫网",
        url: "https://www.hanmanwang.com",
        description: "专业的韩国漫画在线阅读平台",
        contactPoint: {
          "@type": "ContactPoint",
          telephone: "400-888-6666",
          contactType: "customer service",
          availableLanguage: "Chinese",
        },
      },
      {
        "@type": "WebPage",
        name: "韩漫网 - 在线漫画阅读平台",
        description: "在韩漫网，免费在线看好看的漫画和韩国漫画，资源齐全加载快速，涵盖热血、爱情、冒险等多种题材。",
        url: "https://www.hanmanwang.com",
        isPartOf: { "@id": "https://www.hanmanwang.com/#website" },
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
}